import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	movePriorityModalHeader: {
		id: 'admin-pages-priorities.priority-modals.move-modal.move-priority-modal-header',
		defaultMessage: 'Select priority position',
		description: 'Modal header for moving a priority to a specified position number',
	},
	movePriorityModalRequiredFieldsMessage: {
		id: 'admin-pages-priorities.priority-modals.move-modal.move-priority-modal-required-fields-message',
		defaultMessage: 'Required fields are marked with an asterisk.',
		description: 'Move priority modal content for required fields asterisk message',
	},
	movePriorityModalBody: {
		id: 'admin-pages-priorities.priority-modals.move-modal.move-priority-modal-body',
		defaultMessage: 'Re-order priorities by entering the new position number for "{priorityName}."',
		description: 'Modal body content for moving a priority',
	},
	cancelButton: {
		id: 'admin-pages-priorities.priority-modals.move-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Action button to exit the modal for moving a priority',
	},
	confirmButton: {
		id: 'admin-pages-priorities.priority-modals.move-modal.confirm-button',
		defaultMessage: 'Confirm',
		description: 'Primary call to action button in the modal to move a priority',
	},
	orderFieldLabel: {
		id: 'admin-pages-priorities.priority-modals.move-modal.order-field-label',
		defaultMessage: 'Enter priority position number',
		description: 'Field label for position in the form to move a priority',
	},
	orderFieldPlaceholder: {
		id: 'admin-pages-priorities.priority-modals.move-modal.order-field-placeholder',
		defaultMessage: 'Please enter a whole number from 1 to {maximumOrderValue}.',
		description: 'Field label for position in the form to move a priority',
	},
	orderFieldError: {
		id: 'admin-pages-priorities.priority-modals.move-modal.order-field-error',
		defaultMessage: 'Select a number between 1 and {maximumOrderValue}.',
		description: 'Error message for invalid input when setting a new position number',
	},
});
